const isEmpty = (v) => v === '' || v == null;

export const isValidLat = (v) => {
    const n = parseFloat(v);
    return !Number.isNaN(n) && n >= -90 && n <= 90;
};

export const isValidLng = (v) => {
    const n = parseFloat(v);
    return !Number.isNaN(n) && n >= -180 && n <= 180;
};

export const validateCoordinateFields = (latitude, longitude) => {
    const errors = {};
    let valid = true;

    if (!isEmpty(latitude) && !isValidLat(latitude)) {
        errors.latitude = { error: true, helperText: 'Latitude must be between -90 and 90' };
        valid = false;
    }
    if (!isEmpty(longitude) && !isValidLng(longitude)) {
        errors.longitude = { error: true, helperText: 'Longitude must be between -180 and 180' };
        valid = false;
    }

    return { valid, errors };
};
